import React from "react";
import { DateRangePicker } from "rsuite";
import { predefinedRanges } from "./predefinedRanges";
import "rsuite/dist/rsuite.min.css";

// const DatePicker = ({
//   value,
//   onChange,
//   // onOk,
//   // onClean
// }) => {
//   return (
//     <DateRangePicker
//       ranges={predefinedRanges}
//       style={{ width: 200 }}
//       placement='auto'
//       format='dd MMMM yyyy'
//       value={value}
//       // onOk={onOk}
//       onChange={onChange}
//     // onClean={onClean}
//     />
//   );
// };



const DatePicker = ({
  value,
  onChange,
}) => {
  const disabledDate = (date) => {
        return date > new Date();
  };

  return (
    <DateRangePicker
      ranges={predefinedRanges}
      style={{ width: 200 ,padding:"5px"}}
      placement='auto'
      format='dd MMMM yyyy'
      value={value}
      disabledDate={disabledDate}
      onChange={onChange}
    />
  );
};

export default DatePicker;
